import { stacktrace } from "..";

describe('parse', () => {
    test('parse basic error', async () => {
        const error = new Error("Basic Error");
        const { message, name, traces } = await stacktrace.parse(error);

       console.log("traces: ", traces);
    })
})